import { Component, ElementRef, OnInit } from '@angular/core';
import { ModalRef } from 'src/app/shared/utils/modal/modal-ref';
import { LanguageUtilService } from 'src/app/services/language-util.service';
import { Commons } from '../../commons';
import { NgIf } from '@angular/common';
import { TranslocoPipe } from '@ngneat/transloco';

export interface LangItem {
  code: string
  icon: string
  label: string
}

@Component({
  selector: 'app-select-language-modal',
  templateUrl: './select-language-modal.component.html',
  styleUrls: ['./select-language-modal.component.scss'],
  imports: [NgIf, TranslocoPipe]
})
export class SelectLanguageModalComponent implements OnInit {
  languages: LangItem[] = [
    {
      code: 'en',
      icon: './assets/img/languages/en.png',
      label: 'language.en-name'
    }
  ]
  icon: string = Commons.ICON_WARNING

  constructor(
    public modalRef: ModalRef<SelectLanguageModalComponent>,
    private langServ: LanguageUtilService,
    private el: ElementRef
  ) { }

  get activeLang(): string {
    return this.langServ.getLangActive()
  }

  ngOnInit(): void {
    this.languages = this.langServ.getValidLanguages().map(item => ({
      code: item,
      icon: './assets/img/languages/' + item + '.png',
      label: 'language.' + item + '-name'
    }))

    // Neutralize the Bootstrap .modal-content wrapper injected by the modal service
    const modalContent = (this.el.nativeElement as HTMLElement).closest('.modal-content') as HTMLElement
    if (modalContent) {
      modalContent.style.background = 'transparent'
      modalContent.style.border = 'none'
      modalContent.style.boxShadow = 'none'
      modalContent.style.borderRadius = '0'
    }
  }

  setLang(arg: string): void {
    this.modalRef.close(arg)
  }

  cancel(): void {
    this.modalRef.close(this.langServ.getLangActive())
  }

}
